import { createDecorator } from '../../../../platform/instantiation/common/instantiation.js';
const IExplorerService = ( createDecorator('explorerService'));
export { IExplorerService };
